module.exports = __webpack_public_path__ + "img/send-nor.d035dbcb.svg";